// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"ff4e520b","243":"56aa6c3b","374":"8f34b04a","393":"4f793a14","453":"f9d06b21","681":"0805a3cc","848":"cb991c4c","876":"db797f3e"}[chunkId] + ".chunk.js";
};